'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenSearchPaginator = exports.PagedSearchProgressEmitter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventEmitter = require('event-emitter');

var _eventEmitter2 = _interopRequireDefault(_eventEmitter);

var _search = require('./search');

var _utils = require('./utils');

var _config2 = require('./config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @module opensearch/paginator
 */

/**
 * Event emitter to track the progress of paged searches.
 *
 * @fires PagedSearchProgressEmitter#page
 * @fires PagedSearchProgressEmitter#success
 * @fires PagedSearchProgressEmitter#error
 */
var PagedSearchProgressEmitter = function (_EventEmitter) {
  _inherits(PagedSearchProgressEmitter, _EventEmitter);

  function PagedSearchProgressEmitter() {
    _classCallCheck(this, PagedSearchProgressEmitter);

    return _possibleConstructorReturn(this, (PagedSearchProgressEmitter.__proto__ || Object.getPrototypeOf(PagedSearchProgressEmitter)).apply(this, arguments));
  }

  return PagedSearchProgressEmitter;
}(_eventEmitter2.default);

/**
 * Search Progress Event
 *
 * @event module:opensearch/paginator~PagedSearchProgressEmitter#page
 * @type {SearchResult}
 */

/**
 * Search Success Event
 *
 * @event module:opensearch/paginator~PagedSearchProgressEmitter#success
 * @type {SearchResult}
 */

/**
 * Search Error Event
 *
 * @event module:opensearch/paginator~PagedSearchProgressEmitter#error
 * @type {Error}
 */

exports.PagedSearchProgressEmitter = PagedSearchProgressEmitter;


function isCancellable(promise) {
  return promise && typeof promise.cancel === 'function' && !promise.isCancelled();
}

function combinePages(pages) {
  var firstPage = pages[0];
  var records = pages.reduce(function (rs, page) {
    return rs.concat(page.records);
  }, []);
  return {
    totalResults: firstPage.totalResults,
    startIndex: firstPage.startIndex,
    itemsPerPage: firstPage.itemsPerPage,
    records: records
  };
}

/**
 * Class to help with paginated results of an OpenSearch service.
 */

var OpenSearchPaginator = exports.OpenSearchPaginator = function () {
  /**
   * @param {OpenSearchUrl} url The URL to perform all subsequent requests on.
   * @param {object} parameters Search parameters.
   * @param {object} [options] Additional options for the pagination
   * @param {boolean} [options.useCache=true] Whether response pages shall be cached.
   * @param {int} [options.preferredItemsPerPage=undefined] The preferred page size. This
   *                                                        defaults to the advertised
   *                                                        default of the URL.
   * @param {boolean} [options.preferStartIndex=true] Whether the paging shall be done
   *                                                  using the `startIndex` parameter
   *                                                  (the default) or the `startPage`.
   * @param {int} [options.totalResults=undefined] Total results on all pages. Can be set from
   *                                            previous searches for optimized `searchFirstRecords`
   * @param {int} [options.baseOffset=0] The base index offset to apply. This option
   *                                     is useful when resuming a consecutive search.
   * @param {int} [options.maxUrlLength=undefined] The maximum URL length. Forwarded to
   *                                               [search]{@link module:opensearch/search.search}.
   * @param {boolean} [options.dropEmptyParameters=false] Whether unused parameter keys shall
   *                                                      be dropped from the request.
   */
  function OpenSearchPaginator(url, parameters) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, OpenSearchPaginator);

    var _options$useCache = options.useCache,
        useCache = _options$useCache === undefined ? true : _options$useCache,
        _options$preferredIte = options.preferredItemsPerPage,
        preferredItemsPerPage = _options$preferredIte === undefined ? undefined : _options$preferredIte,
        _options$preferStartI = options.preferStartIndex,
        preferStartIndex = _options$preferStartI === undefined ? true : _options$preferStartI,
        _options$baseOffset = options.baseOffset,
        baseOffset = _options$baseOffset === undefined ? 0 : _options$baseOffset,
        _options$totalResults = options.totalResults,
        totalResults = _options$totalResults === undefined ? undefined : _options$totalResults,
        searchOptions = _objectWithoutProperties(options, ['useCache', 'preferredItemsPerPage', 'preferStartIndex', 'baseOffset', 'totalResults']);

    this._url = url;
    this._parameters = parameters;
    this._cache = useCache ? {} : null;
    this._preferredItemsPerPage = preferredItemsPerPage;
    this._preferStartIndex = preferStartIndex;
    this._baseOffset = baseOffset;
    this._totalResults = totalResults;
    this._searchOptions = searchOptions;
  }

  /**
   * Fetch a single page of the result set. Sets the server side items per page,
   * when the result is available.
   * @param {int} [pageIndex=0] The index of the page to be fetched.
   * @param {int} [maxCount=undefined] The maximum count of objects to be retrieved.
   * @returns {Promise<SearchResult>} The search result.
   * @fulfill {module:opensearch/formats~SearchResult} The search result
   */


  _createClass(OpenSearchPaginator, [{
    key: 'fetchPage',
    value: function fetchPage() {
      var _this2 = this;

      var pageIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var maxCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      // TODO: implement caching of whole pages
      // if (this._cache && this._cache[pageIndex]) {
      //   return this._cache[pageIndex];
      // }
      var parameters = (0, _utils.assign)({}, this._parameters);

      var pageSize = this.getActualPageSize();
      if (pageSize && maxCount) {
        parameters.count = Math.min(maxCount, pageSize);
      } else if (pageSize) {
        parameters.count = pageSize;
      } else if (maxCount) {
        parameters.count = maxCount;
      }

      if (this._preferStartIndex) {
        if (typeof pageSize === 'undefined') {
          parameters.startIndex = this._baseOffset + this._url.indexOffset;
        } else {
          parameters.startIndex = this._baseOffset + pageSize * pageIndex + this._url.indexOffset;
        }
      } else {
        parameters.startPage = pageIndex + this._url.pageOffset;
      }
      return (0, _search.search)(this._url, parameters, this._searchOptions).then(function (result) {
        _this2._totalResults = result.totalResults;
        if (!_this2._serverItemsPerPage && result.itemsPerPage) {
          _this2._serverItemsPerPage = result.itemsPerPage;
        }
        return result;
      });
    }

    /**
     * Fetches all pages from the URL. A probing request is sent to determine how
     * many succeeding requests have to be sent.
     * @returns {Promise<SearchResult[]>} The async result of all the pages in the
     *                                    search.
     * @fulfill {module:opensearch/formats~SearchResult[]} The search result pages
     */

  }, {
    key: 'fetchAllPages',
    value: function fetchAllPages() {
      var _this3 = this;

      return this.fetchPage().then(function (firstPage) {
        var pageCount = _this3.getPageCount();
        var requests = [firstPage];
        for (var i = 1; i < pageCount; ++i) {
          requests.push(_this3.fetchPage(i));
        }

        var _config = (0, _config2.config)(),
            Promise = _config.Promise;

        return Promise.all(requests);
      });
    }

    /**
     * Convenience method to get the records of all pages in a single result array
     * @returns {Promise<SearchResult>} The records of all the pages in the search.
     * @fulfill {module:opensearch/formats~SearchResult} The search result
     */

  }, {
    key: 'fetchAllRecords',
    value: function fetchAllRecords() {
      return this.fetchAllPages().then(function (pages) {
        var firstPage = pages[0];
        var records = pages.reduce(function (rs, page) {
          return rs.concat(page.records);
        }, []);
        return {
          totalResults: firstPage.totalResults,
          startIndex: firstPage.startIndex,
          itemsPerPage: firstPage.itemsPerPage,
          records: records
        };
      });
    }

    /**
     * Fetches the first X records of a search in a single search result.
     * @param {int} maxCount The maximum number of records to fetch.
     * @returns {Promise<SearchResult>} The resulting records as a promise.
     * @fulfill {module:opensearch/formats~SearchResult} The search result
     */

  }, {
    key: 'fetchFirstRecords',
    value: function fetchFirstRecords(maxCount) {
      var _this4 = this;

      // Get the first page
      return this.fetchPage(0, maxCount).then(function (firstPage) {
        // check if all records fit in the first page (then return this page)
        if (firstPage.totalResults <= firstPage.itemsPerPage) {
          // return if we already have all records
          return firstPage;
        }
        // fetch other pages until we have the required count
        var requests = [firstPage];
        var usedMaxCount = Math.min(maxCount, firstPage.totalResults - firstPage.startIndex + _this4._url.indexOffset);

        // determine the number of pages and issue a request for each
        var numPages = firstPage.itemsPerPage ? Math.ceil(usedMaxCount / firstPage.itemsPerPage) : 1;
        for (var i = 1; i < numPages; ++i) {
          var count = firstPage.itemsPerPage;
          if (firstPage.itemsPerPage * (i + 1) > usedMaxCount) {
            count = usedMaxCount - firstPage.itemsPerPage * i;
          }
          requests.push(_this4.fetchPage(i, count));
        }

        return Promise.all(requests).then(function (pages) {
          return combinePages(pages);
        });
      });
    }

    /**
     * Fetches the first X records of a search in a single search result.
     * Use this method when the progressive results are wished and not just a
     * final result.
     * @param {int} maxCount The maximum number of records to fetch.
     * @param {boolean} preserveOrder Whether the results must be returned in the
     *                                order received from the server, or the
     *                                originally requested order.
     * @returns {module:opensearch/paginator~PagedSearchProgressEmitter} The resulting
     *                                                                   records as a promise.
     */

  }, {
    key: 'searchFirstRecords',
    value: function searchFirstRecords() {
      var _this5 = this;

      var maxCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var preserveOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      // Get the first page
      var emitter = new PagedSearchProgressEmitter();
      var request = null;
      var startPageIndex = null;
      if (this._preferredItemsPerPage && this._totalResults && typeof maxCount !== 'undefined' && maxCount !== 0) {
        // if paginator created based on known values - continue search
        // do not request first page to get values
        request = Promise.resolve({
          itemsPerPage: this._preferredItemsPerPage,
          records: [],
          totalResults: this._totalResults,
          startIndex: this._baseOffset
        });
        startPageIndex = 0;
      } else {
        // start requesting the first page
        request = this.fetchPage(0, maxCount);
        startPageIndex = 1;
      }
      var requests = [request];

      // cancel requests when issued a cancel event
      emitter.on('cancel', function () {
        requests.forEach(function (req) {
          if (isCancellable(req)) {
            req.cancel();
          }
        });
      });

      var hasError = false;
      var onError = function onError(error) {
        hasError = true;
        emitter.emit('error', error);
        return error;
      };

      request.catch(onError).then(function (firstPage) {
        if (hasError) {
          throw firstPage;
        }
        // save the first page as a resolved promise (for later use when
        // collecting results in a uniform fashion) in case it was fetched
        var newRequests = [];
        if (startPageIndex === 1) {
          newRequests.push(Promise.resolve(firstPage));
        }
        var usedMaxCount = maxCount ? Math.min(maxCount, firstPage.totalResults - firstPage.startIndex + _this5._url.indexOffset) : firstPage.totalResults;

        // determine the number of pages and issue a request for each
        var numPages = firstPage.itemsPerPage ? Math.ceil(usedMaxCount / firstPage.itemsPerPage) : 1;
        for (var i = startPageIndex; i < numPages; ++i) {
          var count = firstPage.itemsPerPage;
          if (firstPage.itemsPerPage * (i + 1) > usedMaxCount) {
            count = usedMaxCount - firstPage.itemsPerPage * i;
          }
          newRequests.push(_this5.fetchPage(i, count));
        }

        // save the requests in the global variable to allow cancellation/result collection
        requests = newRequests;

        var pages = Array(requests.length);

        if (preserveOrder) {
          (function () {
            // when the order of the the responses is important, the algorithm is
            // more complex
            var index = 0;
            var allRequests = Array.from(requests);
            var onPage = function onPage(page) {
              if (hasError) {
                return;
              }
              pages[index] = page;
              index += 1;
              emitter.emit('page', page);
              var promise = allRequests.shift();
              if (promise) {
                promise.then(onPage, onError);
              } else {
                emitter.emit('success', combinePages(pages)); // TODO:
              }
            };
            allRequests.shift().then(onPage, onError);
          })();
        } else {
          (function () {
            var successCount = 0;
            requests.forEach(function (req, index) {
              req.then(function (page) {
                if (hasError) {
                  return;
                }
                successCount += 1;
                pages[index] = page;
                if (successCount === requests.length) {
                  emitter.emit('success', combinePages(pages)); // TODO
                }
              }, onError);
            });
          })();
        }
      });
      return emitter;
    }

    /**
     * Returns the actual page size.
     * @returns {int} The computed page size.
     */

  }, {
    key: 'getActualPageSize',
    value: function getActualPageSize() {
      if (this._preferredItemsPerPage && this._serverItemsPerPage) {
        return Math.min(this._preferredItemsPerPage, this._serverItemsPerPage);
      } else if (this._serverItemsPerPage) {
        return this._serverItemsPerPage;
      } else if (this._preferredItemsPerPage) {
        return this._preferredItemsPerPage;
      }
      var countParam = this._url.getParameter('count');
      if (countParam) {
        if (typeof countParam.maxExclusive !== 'undefined') {
          return countParam.maxExclusive - 1;
        } else if (countParam.maxInclusive) {
          return countParam.maxInclusive;
        }
      }
      return undefined;
    }

    /**
     * Returns the computed number of pages, which is available once the first page
     * was received.
     * @returns {int} The number of pages.
     */

  }, {
    key: 'getPageCount',
    value: function getPageCount() {
      var pageSize = this.getActualPageSize();
      if (!this._totalResults) {
        return this._totalResults;
      } else if (!pageSize) {
        return undefined;
      }
      return Math.ceil(this._totalResults / pageSize);
    }
  }]);

  return OpenSearchPaginator;
}();


// WEBPACK FOOTER //
// /~/opensearch-browser/dist/paginator.js